module.exports = __webpack_public_path__ + "img/landing-treatment-screen-2.b621514c.png";